$(function() {

    const initScrollToTop = () => {
        const scrollBlock = document.createElement('div'),
              windowHeight = document.documentElement.clientHeight;
        scrollBlock.classList.add('scroll-to-top');
        document.body.append(scrollBlock);
        scrollBlock.innerHTML = `
        <svg width="20" height="31" viewBox="0 0 20 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29289 0.792893C9.68342 0.402369 10.3166 0.402369 10.7071 0.792893L19.7071 9.79289C20.0976 10.1834 20.0976 10.8166 19.7071 11.2071C19.3166 11.5976 18.6834 11.5976 18.2929 11.2071L11 3.91421V29.5C11 30.0523 10.5523 30.5 10 30.5C9.44771 30.5 9 30.0523 9 29.5V3.91421L1.70711 11.2071C1.31658 11.5976 0.683417 11.5976 0.292893 11.2071C-0.0976311 10.8166 -0.0976311 10.1834 0.292893 9.79289L9.29289 0.792893Z" fill="#C8D6E4"/>
        </svg>
        `

        scrollBlock.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        })

        document.addEventListener('scroll', () => {
            if (document.documentElement.scrollTop >= windowHeight * 1.5 &&  document.documentElement.scrollTop + windowHeight / 2 >= document.body.scrollHeight / 2) {
                scrollBlock.classList.add('active')
            } else {
                scrollBlock.classList.remove('active')
            }
        })
    }

    if (document.querySelector('.block.calc.calc_model.page')) {
        const forms = document.querySelectorAll('.block.calc.calc_model.page');

        forms.forEach(form => {
            var formBg = form.querySelector('.form__calc-bg');

            if (formBg) {
                formBg.style.display = 'none';
            }
        })
    }

    if (document.querySelector('.phone-fixed')) {
        const paddingMenu = document.querySelector('.phone-fixed').clientHeight;

        document.querySelector('.new-header .main-nav__scrollable').style.paddingBottom = paddingMenu + 'px';
    }

    if (!document.querySelector('.js-scroll-up')) {
        initScrollToTop();
    }

    function validateFieldForm() {
        document.addEventListener('input', (e) => {
            if (e.target.name === 'NAME') {
                e.target.value = e.target.value.replace(/[^a-zа-я]/gi, '');
            }
        })
    }

    validateFieldForm();

  if ($(".js-gallery-slider").length){
   gallerySliderInit();
  }

  if ($(".js-services-tab").length){
   servicesTabInit()
  }

  var vw = $(window).width();
  if (vw >= 768) {
    servicesList();
    if ($(".js-scrollable").length) {
      $(".js-scrollable").each(function(){
        scrollable($(this));
      })
    }
  }

  loadCarsList();
  mainNav();
  menu();
  smoothScroll();

  if ($(".js-main-slider").length){
    mainSliderInit();
  }

  if ($(".js-service-slider").length){
	specialService();
  }
  if ($(".reviews-slider").length){
	reviewsSlider();
  }

    if ($(".similar-errors-slider").length) {
        otherErrorsSliderInit();
    }

  $(".js-tags-list-more").on("click", function() {
    $(this).closest(".js-tags-list").toggleClass("is-expand");
  });

  // Тултипы обратной связи - contacts.html
  // const tmplFeedbackTooltip = document.getElementById(`feedback-tooltip`);

  // Тултип шаринга в соцсетях

  // объект для шаринга
  let shareState = {
    url: '',
    title: '',
    img: '',
    text: '',
  };

  // собственно тултип

  function createTooltip({url='', title='', img='', text=''}) {
    return  `<div class="tooltip-share">
    <ul class="tooltip-share__list">
      <li class="tooltip-share__item">
          <a href="#" class="tooltip-share__link js-shared-link" data-site="twitter" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">
              <svg class="tooltip-share__icon">
                  <use xlink:href="#twitter"></use>
              </svg>
          </a>
      </li>
      <li class="tooltip-share__item">
          <a href="#" class="tooltip-share__link js-shared-link" data-site="telegram" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">
              <svg class="tooltip-share__icon">
                  <use xlink:href="#telegram"></use>
              </svg>
          </a>
      </li>
      <li class="tooltip-share__item">
          <a href="#" class="tooltip-share__link js-shared-link" data-site="facebook" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">
              <svg class="tooltip-share__icon">
                  <use xlink:href="#facebook"></use>
              </svg>
          </a>
      </li>
      <li class="tooltip-share__item">
          <a href="#" class="tooltip-share__link js-shared-link" data-site="vk" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">
              <svg class="tooltip-share__icon">
                  <use xlink:href="#vk"></use>
              </svg>
          </a>
      </li>
      <li class="tooltip-share__item">
          <a href="#" class="tooltip-share__link js-shared-link" data-site="pinterest" data-url="${url}" data-title="${title}" data-desc="${text}" data-img="${img}">
              <svg class="tooltip-share__icon">
                  <use xlink:href="#pinterest"></use>
              </svg>
          </a>
      </li>
      <li class="tooltip-share__item">
          <svg class="tooltip-share__icon">
              <use xlink:href="#share"></use>
          </svg>
      </li>
    </ul>
</div>
`
  }

  // при показе заново создается тултип с правильными data атрибутами
  const tooltipItems = document.querySelectorAll('.js-tooltip-item');
  tooltipItems.forEach((el) => {
      const triggerEl = el.querySelector('.js-tooltip-trigger');

      tippy(el, {
        theme: 'light',
        interactive: true,
        allowHTML: true,
        content: createTooltip(shareState),
        placement: 'bottom-end',
        offset: [0, 0],
        maxwidth: 280,
        triggerTarget: triggerEl,
        arrow: false,
        zIndex: 1000,
        onShow(instance) {
            const shareState = instance.reference.dataset;
            instance.setContent(createTooltip(shareState))
        },
        popperOptions: {
            modifiers: [
              {
                name: 'flip',
                enabled: false,
              },
            ],
          },
      });
  })

  // генерируем url

  const Share = {
	vkontakte: function(purl, ptitle, pimg, text) {
        let url  = 'http://vkontakte.ru/share.php?';
		url += 'url='          + encodeURIComponent(purl);
		url += '&title='       + encodeURIComponent(ptitle);
		url += '&description=' + encodeURIComponent(text);
		url += '&image='       + encodeURIComponent(pimg);
		url += '&noparse=true';
		Share.popup(url);
	},
	facebook: function(purl, ptitle, pimg, text) {
		let url  = 'http://www.facebook.com/sharer.php?s=100';
		url += '&p[title]='     + encodeURIComponent(ptitle);
		url += '&p[summary]='   + encodeURIComponent(text);
		url += '&p[url]='       + encodeURIComponent(purl);
		url += '&p[images][0]=' + encodeURIComponent(pimg);
		Share.popup(url);
	},
	twitter: function(purl, ptitle) {
		let url  = 'http://twitter.com/share?';
		url += 'text='      + encodeURIComponent(ptitle);
		url += '&url='      + encodeURIComponent(purl);
		url += '&counturl=' + encodeURIComponent(purl);
		Share.popup(url);
	},
	pinterest: function(purl, pimg, text) {
		let url  = 'http://www.pinterest.com/pin/create/button/?';
		url += 'url='      + encodeURIComponent(purl);
		url += '&media='      + encodeURIComponent(pimg);
		url += '&description=' + encodeURIComponent(text);
		Share.popup(url);
	},
    telegram: function(purl, text) {
        let url  = `https://telegram.me/share/url?`;
        url += `url=`      + encodeURIComponent(purl);
        url += `&text=` + encodeURIComponent(text);
        Share.popup(url);
    },

	popup: function(url) {
		window.open(url,'','toolbar=0,status=0,width=626,height=436');
	},
};


document.addEventListener('click', function(ev) {
    const target = ev.target.closest('.js-shared-link');
    if(!target) return;
    const site = target.dataset.site;

    switch(site) {
        case 'twitter':
            Share.twitter(target.dataset.url, target.dataset.title);
            break;
        case 'facebook':
            Share.facebook(target.dataset.url, target.dataset.desc);
            break;
        case 'vk':
            Share.vkontakte(target.dataset.url, target.dataset.title, target.dataset.img, target.dataset.desc);
            break;
        case 'pinterest':
            Share.pinterest(target.dataset.url, target.dataset.img, target.dataset.desc);
            break;
        case 'telegram':
            Share.telegram(target.dataset.url, target.dataset.desc);
            break;
        default:
    }

});

// шаринг: отключить переход по ссылке на мобильном
    $('.js-tooltip-trigger').on('click', function(ev) {
        ev.preventDefault();
    })


    $(`.js-comment-form`).on(`submit`, function(e) {
        e.preventDefault();

        const $this = $(this);

        $.ajax({
            type: `POST`,
            url: $this.data(`url`),
            data: $this.serialize(),

            success: (data) => {
               $this[0].reset();
               const containerMessage = document.querySelector('.js-comment-form .subscribe-form__item');

               if (containerMessage) {
                    let div = document.querySelector('.js-comment-form .success__message')
                    if (!div) {
                        div = document.createElement('div');
                        div.className = 'success__message';
                        div.textContent = 'Вы подписались на рассылку';
                        containerMessage.append(div);
                    }

                    setTimeout(() => {
                        div.classList.add('active');
                    })

                    setTimeout(() => {
                        div.classList.remove('active');
                    }, 5000);
               }
            },
            error: (request) => {
                $this[0].reset();
            }
        });
    });

    // сокращает строки


    function truncateDesc(mode) {
        const truncateElements = document.querySelectorAll('.js-truncate-desc');

        if(mode === 'small') {
            truncateElements.forEach(el => {
                // у большой 6, у остальных 2
                const linesCount = el.dataset.lines == 11 ? 6 : 2;
                $clamp(el, {clamp: linesCount});
            });
            return
        }

        truncateElements.forEach(el => {
            const linesCount = el.dataset.lines
            $clamp(el, {clamp: linesCount});
        });
    }

    function truncateTitle() {
        const truncateElements = document.querySelectorAll('.js-truncate-title');

        truncateElements.forEach(el => {
            const linesCount = el.dataset.lines
            $clamp(el, {clamp: linesCount});
        });
    }

    let truncateMode = window.innerWidth <= 1280 ? 'small' : 'default';
    truncateTitle();
    truncateDesc(truncateMode);

    window.addEventListener('resize', function() {
        const newMode = window.innerWidth <= 1280 ? 'small' : 'default';
        if(newMode === truncateMode) return

        truncateDesc(newMode);
        truncateMode = newMode;
    });
})


window.addEventListener('load', () => {
    function testWebP(callback) {
        let webP = new Image();
        webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
        webP.onload = webP.onerror = function () {
            callback(webP.height === 2);
        };
    };

    setTimeout(() => {
        testWebP(function(support) {
            console.log(support);
            if (!support) {
                const allImg = document.querySelectorAll('img');

                allImg.forEach(img => {
                    let srcImage = img.src;
                    if (srcImage && srcImage.endsWith('.webp')) {
                        if (img.dataset.src) {
                            srcImage = img.dataset.src;
                        }

                        const newSrcImage = srcImage.substring(0, srcImage.length - 5);

                        img.setAttribute('src', newSrcImage);
                    } else if (img.dataset.src) {
                        console.log(img);
                        srcImage = img.dataset.src;

                        const newSrcImage = srcImage.substring(0, srcImage.length - 5);

                        img.setAttribute('src', newSrcImage);
                    }
                })
            }
        });
    }, 800)


    //zoom страницы для широких экранов
    $(document).ready(function ($) {

        nsZoomZoom();

        $(window).resize(function () {
            nsZoomZoom();
        });

        function nsZoomZoom() {
            let htmlWidth = $('html').innerWidth();
            let bodyWidth = 1920;

            let scale = htmlWidth < bodyWidth ? 1 : htmlWidth / bodyWidth;

            $("body").css('zoom', scale);
            $("body").css('-ms-zoom', scale);
            $("body").css('-moz-transform', 'scale(' + scale + ')');
        }
    });



    let scrollLinks = document.querySelectorAll('a[href="#menu-scroll__price"], a[href="#menu-scroll__also"], a[href="#menu-scroll__gallery"]');

    function makeAnchors() {
        const articlePageWrapper = document.querySelector('.article section');
        const originalHeaders = document.querySelector('article section .article-nav .article-nav__inner');

        if(originalHeaders) { // если в DETAIL_TEXT уже есть содержание, ничего не делаем
            return;
        }
        
        if (!articlePageWrapper) {
            return;
        }
        const ul = document.querySelector('article.article .js-article-nav__inner');
        console.log()
        if (!ul || !articlePageWrapper) {
            return;
        }
        const headers = articlePageWrapper.querySelectorAll('h2, h3');
        const contentHeaders = [];
        headers.forEach((header, index) => {
            console.log(header, ' header');
            header.id = `section-${index}`;
        });

        // if (headers.length !== 0) {
        //     content.classList.remove('detail-article__contents--hidden');
        // }
    }

    makeAnchors();

    // Добавляем обработчик события click для каждой ссылки
    scrollLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            // Получаем цель (id элемента, к которому нужно прокрутить)
            var targetId = this.getAttribute('href').substring(1);
            var targetElement = document.getElementById(targetId);

            // Прокручиваем страницу к цели с плавным скроллом
            targetElement.scrollIntoView({
                behavior: 'smooth'
            });
        });
    });

    function copyTextToClipboard(text, promiseReturn = false) {
        if (!navigator.clipboard) {
            return fallbackCopyTextToClipboard(text);
        }

        if (promiseReturn) {
            return navigator.clipboard.writeText(text);
        }

        navigator.clipboard.writeText(text).then(() => {
            console.log('Значение успешно скопировано');
            return true;
        }, (err) => {
            console.error('Ошибка при копировании: ', err);
            return false;
        })
    }

    function fallbackCopyTextToClipboard(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;

        textArea.style.bottom = '0';
        textArea.style.right = '0';
        textArea.style.position = 'fixed';
        debugger;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        let success = false;

        try {
            const copyRes = document.execCommand('copy');

            let copyMsg = 'неуспешно';

            if (copyRes) {
                success = true;
                copyMsg = 'успешно';
            }

            console.log('Копирование значения ' + copyMsg);
        } catch (err) {
            console.error('Копирование завершено с ошибкой: ', err);
        }

        document.body.removeChild(textArea);

        return success;
    }

    if(window.location.href.includes('/blog/')) {
        function setCopyLink() {
            const copyLinkElement = document.querySelectorAll('.js-share-list__item--link-copy');
            console.log(copyLinkElement,' like element');
            copyLinkElement.length > 0 && copyLinkElement.forEach(item => item.addEventListener('click', () => {
                copyTextToClipboard(window.location.href);

                const copiedMessage = item.querySelector('.js-share-list__share-message');
                console.log(copiedMessage)

                if (copiedMessage) {
                    copiedMessage.classList.add('_copied');

                    setTimeout(() => {
                        copiedMessage.classList.remove('_copied');
                    }, 3000);
                }
            }));
        }
        setCopyLink();
    }

})
